import {
  cookiesFromCell,
  disableTargetsFromCell,
  excludeReferrersFromCell,
  referrersFromCell,
  splitListCell,
  targetContentsFromCell,
  urlsFromCell,
} from "./parsePopupCsvRow";

export function formatStringList(ids: string[] | undefined): string {
  return (ids ?? []).filter(Boolean).join("; ");
}

export function parseStringList(raw: string): string[] {
  return splitListCell(raw);
}

export function formatReferrers(
  rows: { referrer: string; matchOp: string }[] | undefined
): string {
  const r = rows ?? [];
  if (r.length === 0) return "";
  if (r.every((x) => (x.matchOp || "EQUAL") === "EQUAL")) {
    return r
      .map((x) => x.referrer)
      .filter(Boolean)
      .join("; ");
  }
  return JSON.stringify(r);
}

export function parseReferrersCell(raw: string) {
  return referrersFromCell(raw);
}

export function parseExcludeReferrersCell(raw: string) {
  return excludeReferrersFromCell(raw);
}

export function formatUrlList(rows: { url: string }[] | undefined): string {
  return (rows ?? [])
    .map((x) => x.url)
    .filter(Boolean)
    .join("; ");
}

export function parseUrlListCell(raw: string) {
  return urlsFromCell(raw);
}

export function formatJsonArray<T>(rows: T[] | undefined): string {
  const r = rows ?? [];
  if (r.length === 0) return "";
  return JSON.stringify(r);
}

export function parseTargetContentsCell(raw: string) {
  return targetContentsFromCell(raw);
}

export function parseDisableTargetsCell(raw: string) {
  return disableTargetsFromCell(raw);
}

export function formatCookiesForCell(
  rows: { key: string; value: string; matchType: boolean }[] | undefined
): string {
  const r = rows ?? [];
  if (r.length === 0) return "";
  return JSON.stringify(r);
}

export function parseCookiesCell(raw: string) {
  return cookiesFromCell(raw);
}
